import React from 'react';
import { Button } from '@veneer/core'; 
import '../../../assets/css/views/activations/customButton.css'; 

interface CustomButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  style?: React.CSSProperties; 
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  onClick,
  disabled = false,
  style,
}) => {
  return (
    <div className="activationButton" style={style}>
      <Button
        disabled={disabled}
        onClick={onClick}
        className="custom-button"
      >
        {children}
      </Button>
    </div>
  );
};

export default CustomButton;
